import { render, staticRenderFns } from "./more-options-duplicate.vue?vue&type=template&id=e23042ba&scoped=true&"
import script from "./more-options-duplicate.vue?vue&type=script&lang=js&"
export * from "./more-options-duplicate.vue?vue&type=script&lang=js&"
import style0 from "./more-options-duplicate.vue?vue&type=style&index=0&id=e23042ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23042ba",
  null
  
)

export default component.exports